/* global Plaid */

import { showSuccess, showError } from 'utils/messages';
import EasyPostConstants from 'app/easypost_constants';

import BankAccount from 'app/models/bank_account';

import Base from 'app/views/base';
import BankAccountDetailsModal from 'app/views/modals/bank_account_details_modal';
import LoaderModal from 'app/views/modals/loader_modal';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .add_account': 'showPlaid',
  },

  initialize({ priority }) {
    this.priority = priority;
    this.detailsModal = new BankAccountDetailsModal({
      model: this.model,
      priority: this.priority,
    });
    this.loaderModal = new LoaderModal();
  },

  showPlaid(e) {
    e.preventDefault();
    const self = this;
    const linkHandler = Plaid.create({
      selectAccount: true,
      env: EasyPostConstants.PlaidEnv,
      clientName: 'EasyPost',
      key: EasyPostConstants.PlaidPublicKey,
      product: 'auth',
      onSuccess(publicToken, metadata) {
        self.completePlaidAuth({
          public_token: publicToken,
          account_id: metadata.account_id,
        });
      },
      onExit() {
        self.showDetailsModal();
      },
    });
    linkHandler.open();
  },

  completePlaidAuth(data) {
    const self = this;
    const account = new BankAccount();
    self.loaderModal.show();
    account.save({
      account_id: data.account_id,
      public_token: data.public_token,
      priority: self.priority,
    }, {
      wait: true,
      success(model) {
        self.loaderModal.close();
        self.model.set(`${self.priority}_payment_method`, model);
        showSuccess('Bank account successfully linked to your account.');
        self.model.trigger('newPaymentMethod');
      },
      error() {
        self.loaderModal.close();
        showError('The bank account details you provided were not accepted by Plaid');
      },
    });
  },

  showDetailsModal() {
    this.detailsModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/payment_methods/bank_account_button/index.js